package com.tovtalk.ui.theme

import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js
import io.ktor.client.request.get
import io.ktor.client.statement.readRawBytes

/** Open Sans woff2 from Google (return 200). Latin subset. */
private const val OPEN_SANS_LATIN = "https://fonts.gstatic.com/s/opensans/v44/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-mu0SC55I.woff2"
/** Open Sans Hebrew subset. */
private const val OPEN_SANS_HEBREW = "https://fonts.gstatic.com/s/opensans/v44/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS2mu0SC55K5gw.woff2"

actual fun getWebFontLatinRegularUrl(): String? = OPEN_SANS_LATIN
actual fun getWebFontLatinBoldUrl(): String? = OPEN_SANS_LATIN
actual fun getWebFontHebrewRegularUrl(): String? = OPEN_SANS_HEBREW
actual fun getWebFontHebrewBoldUrl(): String? = OPEN_SANS_HEBREW

actual suspend fun loadFontBytesFromWebUrl(url: String): ByteArray? = try {
    val client = HttpClient(Js)
    val bytes = client.get(url).readRawBytes()
    client.close()
    bytes
} catch (_: Throwable) {
    null
}
